import Generic from 'src/models/generic/Generic'
import Model, { ID, IsoDateTime, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'

export default class ThirdPartyRewardConfig extends Model {
  static name = 'ThirdPartyRewardConfig'

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Circuit]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true
      },
      providerName: {
        type: String,
        required: true,
        sortable: true
      },
      enabled: {
        type: Boolean,
        required: true,
        default: false
      },
      config: {
        type: JsonObject,
        required: true,
        default: () => ({})
      },
      prefixes: {
        type: JsonArray,
        required: true,
        default: () => []
      },
      createdAt: {
        type: IsoDateTime,
        required: true,
        output: true,
        sortable: true
      },
      updatedAt: {
        type: IsoDateTime,
        required: true,
        output: true,
        sortable: true
      }
    }

    this.queries = {
      availableThirdPartyRewardIntegrations: {
        results: {
          integrations: Generic
        }
      }
    }
  }
}
